import type { VoidFunctionComponent } from 'react';
import cx from 'classnames';
import { onEnter } from '../../../../../utils';
import type { IconClassName } from '../../../../generic/Icon';
import Icon from '../../../../generic/Icon';
import Text from '../../../../generic/Text';
import styles from './SidePanel.module.less';

type Props = {
  id: string;
  name: string;
  icon: IconClassName;
  isActive: boolean;
  onSelect: (id: string) => void;
};

/**
 * Provides list elements for a sidebar minimal nav lists
 * @param {Props} props - props for the list element
 * @param {string} props.id - key for the list element, used for onSelect differentiation
 * @param {string} props.name - name for the list element
 * @param {IconClassName} props.icon - icon for the list element
 * @param {boolean} props.isActive - whether the list element is active
 * @param {Function} props.onSelect - callback for when the list element is selected
 */
const ReportListElement: VoidFunctionComponent<Props> = ({ id, name, icon, isActive, onSelect: onSelectFunc }) => {
  const onSelect = () => onSelectFunc(id);

  return (
    <li id={id}>
      {/* TODO - move away from using this legacy nav-minimal and use a button here */}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/interactive-supports-focus */}
      <a
        onClick={onSelect}
        onKeyDown={onEnter(onSelect)}
        className={cx(
          styles.formatOption,
          {
            active: isActive,
          },
        )}
        role="button"
      >
        <Text.H4>
          <Icon icon={icon} />
          <span>{name}</span>
        </Text.H4>
      </a>
    </li>
  );
};

export default ReportListElement;
